import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargeAdditionalCostsDialogComponent } from './charge-additional-costs-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PaymentElementModule } from '../../../../shared/payment-element/payment-element.module';
import { SharedModule } from '../../../../shared/shared.module';

@NgModule({
  declarations: [ChargeAdditionalCostsDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    PaymentElementModule,
    SharedModule,
  ],
})
export class ChargeAdditionalCostsDialogModule {}
